<template>
  <div class="chat-block-grid" :class="{'show-chat': expanded}">
    <div id="chat-main">
      <div class="chatheader-grid">
        <!-- :class="{'banner-header': externDomain && !externDomainExpanded}"> -->
        <div class="chatbroker-info" v-if="broker.firstName">
          <img :src="broker.profileImage" class="broker-image-mine" alt="">
          <div>
            <div class="chatbroker-name-2">{{ broker.firstName }} {{ broker.lastName }}</div>
            <div class="chatbroker-last-activity-2"> sme {{ isChatOnline ? "online" : "offline" }}</div>
          </div>
        </div>

        <div v-else>
          <div class="chatbroker-info">
            <!-- <img src="../assets/broker-default.jpg" class="broker-image-mine" alt=""> -->
            <div>
              <div class="chatbroker-name-2">Podpora</div>
              <div class="chatbroker-last-activity-2"> sme {{ isChatOnline ? "online" : "offline" }}</div>
            </div>
          </div>
        </div>

        <img @click="expanded = false" class="crossBtn mobile-only"
             src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/65018443a59e45af8776eb27_close%20icon%20white.svg">

        <!-- <div class="d-flex" v-if="externDomain && !externDomainExpanded">
          <div class="custom-link align-self-center margin-right" @click="externDomainExpanded = true">spýtať sa</div>
          <div class="align-self-center">
            <svg class="send-icon" width="35" height="35" viewBox="0 0 35 35" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <circle cx="17.5" cy="17.5" r="17.5" fill="white"/>
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M18.7141 24.7915C18.6988 24.7915 18.6842 24.7908 18.6696 24.79C18.34 24.7703 18.0651 24.5312 17.9995 24.2074L16.878 18.6898C16.8197 18.4025 16.5958 18.1787 16.3086 18.1203L10.7909 16.9982C10.4672 16.9333 10.228 16.6584 10.2083 16.3288C10.1887 15.9985 10.3921 15.6966 10.7056 15.593L22.3723 11.7044C22.6341 11.6154 22.9228 11.684 23.1182 11.8801C23.3137 12.0755 23.3815 12.3643 23.2947 12.6261L19.4053 24.2927C19.3062 24.5924 19.0262 24.7915 18.7141 24.7915Z"
              />
              <mask id="mask0_7205_8812" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="10" y="11" width="14"
                    height="14">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M18.7141 24.7915C18.6988 24.7915 18.6842 24.7908 18.6696 24.79C18.34 24.7703 18.0651 24.5312 17.9995 24.2074L16.878 18.6898C16.8197 18.4025 16.5958 18.1787 16.3086 18.1203L10.7909 16.9982C10.4672 16.9333 10.228 16.6584 10.2083 16.3288C10.1887 15.9985 10.3921 15.6966 10.7056 15.593L22.3723 11.7044C22.6341 11.6154 22.9228 11.684 23.1182 11.8801C23.3137 12.0755 23.3815 12.3643 23.2947 12.6261L19.4053 24.2927C19.3062 24.5924 19.0262 24.7915 18.7141 24.7915Z"
                      fill="white"/>
              </mask>
              <g mask="url(#mask0_7205_8812)">
                <rect x="8.75" y="8.75" width="17.5" height="17.5" fill="none"/>
              </g>
            </svg>
          </div>
        </div> -->
      </div>

      <div v-if="externDomainExpanded" class="chat-panel-grid" :class="{'bannerCenter': !messages.length}">
        <!-- ak bola napísaná správa -->
        <div v-if="messages.length">
          <message v-for="(message, index) in messages" :file-name="message.attachment_filename"
                   :seen="message['seen_at'] !== null" :file="message.attachment"
                   :sender="clientId === message.sender"
                   :content="message.content" :key="`message-${index}`"></message>

          <div class="chat-banner mini" v-if="!isChatOnline">
            <!-- správa mimo pracovného času -->
            <!-- <img class="chatImage" src="https://bankari-production.fra1.digitaloceanspaces.com/frontend_static%2Fchat-online.png" alt=""> -->
            <div class="description">
              na vaše správy obratom odpovieme v pracovnom čase od <span class="darkgreen">9:00</span> do <span
                class="darkgreen">17:00</span>, ak si želáte aby Vám odpoveď prišla na email, napíšte nám ho prosím do
              ďalšej správy
            </div>
          </div>
          <!-- banner pre infomáciu aby zanechali email ak neodpisujeme -->
          <div class="leaveEmailBanner" v-if="isChatOnline">Ak by sme nereagovali, zanechajte nám v správe email a do
            hodiny Vám naň odpíšeme 😊
          </div>
        </div>
        <!-- ak ešte nebola napísaná správa -->
        <div class="no-messages" v-else>
          <div class="chat-banner" v-if="isChatOnline">
            <!-- <img class="chatImage" src=""> -->
            <div class="description">
              Som online, ak máte otázku ohľadom hypotéky alebo kúpy nehnuteľnosti, sem s ňou 😊 alebo rovno začnite
              výpočtom
            </div>
          </div>


          <div class="chat-banner" v-else>
            <!-- keď je chat offline bez správ -->
            <!-- <img class="chatImage" src="https://bankari.s3.eu-central-1.amazonaws.com/frontend_static%2Fchair.png"
                 alt=""> -->
            <div class="description">
              dobrý deň, odpíšeme Vám opäť v pracovnom čase každý deň od <span class="darkgreen">9:00</span> do <span
                class="darkgreen">17:00</span>
            </div>
          </div>
        </div>

      </div>

      <b-collapse id="collapse-1" class="mt-2"
                  v-model="fileCollapsed"
      >
        <div class="file-control">
          <div class="fileNamePart">
            <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M10 0.129883C8.05459 0.129883 6.41718 1.17113 5.35807 2.64128C2.40455 2.67479 0 5.08538 0 8.04655C0 11.0284 2.43478 13.4632 5.41667 13.4632H7.5V11.7965H5.41667C3.33522 11.7965 1.66667 10.128 1.66667 8.04655C1.66667 5.96511 3.33522 4.29655 5.41667 4.29655C5.44583 4.29655 5.51372 4.30237 5.625 4.30794L6.13444 4.33398L6.38835 3.89128C7.10842 2.64018 8.44823 1.79655 10 1.79655C12.0871 1.79655 13.795 3.31779 14.1097 5.30892L14.2367 6.1097L15.0407 6.00553C15.2268 5.9813 15.3458 5.96322 15.4167 5.96322C17.037 5.96322 18.3333 7.25953 18.3333 8.87988C18.3333 10.5002 17.037 11.7965 15.4167 11.7965H12.5V13.4632H15.4167C17.938 13.4632 20 11.4012 20 8.87988C20 6.38791 17.9809 4.36005 15.4997 4.31283C14.7749 1.91453 12.6267 0.129883 10 0.129883ZM10 5.12988L6.66667 8.46322H9.16667V15.1299H10.8333V8.46322H13.3333L10 5.12988Z"
                  fill="#258B66"/>
            </svg>

            <div class="file-name" style="max-width: 300px; word-break: break-word">
              {{ fileName }}
            </div>
          </div>
          <div @click="deleteFile" class="delete-file">
            <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M2.3188 0.616791C2.05366 0.617119 1.79465 0.696477 1.57483 0.844728C1.35502 0.992979 1.18439 1.20339 1.08474 1.44909C0.985096 1.69478 0.960953 1.96461 1.0154 2.22409C1.06985 2.48357 1.20041 2.72093 1.39041 2.90585L5.11437 6.62981L1.39041 10.3538C1.26245 10.4766 1.16028 10.6238 1.0899 10.7866C1.01952 10.9495 0.982342 11.1247 0.980538 11.3021C0.978733 11.4795 1.01234 11.6554 1.07939 11.8197C1.14645 11.9839 1.24559 12.1331 1.37103 12.2586C1.49647 12.384 1.64568 12.4832 1.80991 12.5502C1.97415 12.6173 2.15011 12.6509 2.3275 12.6491C2.50489 12.6473 2.68013 12.6101 2.84297 12.5397C3.00581 12.4693 3.15297 12.3672 3.27583 12.2392L6.99978 8.51523L10.7237 12.2392C10.8466 12.3672 10.9938 12.4693 11.1566 12.5397C11.3194 12.6101 11.4947 12.6473 11.6721 12.6491C11.8495 12.6509 12.0254 12.6173 12.1897 12.5502C12.3539 12.4832 12.5031 12.384 12.6285 12.2586C12.754 12.1331 12.8531 11.9839 12.9202 11.8197C12.9872 11.6555 13.0208 11.4795 13.019 11.3021C13.0172 11.1247 12.9801 10.9495 12.9097 10.7866C12.8393 10.6238 12.7371 10.4766 12.6092 10.3538L8.8852 6.62981L12.6092 2.90585C12.8018 2.71857 12.9334 2.47745 12.9867 2.21409C13.04 1.95073 13.0125 1.67742 12.9077 1.42997C12.803 1.18252 12.626 0.972483 12.3998 0.827377C12.1737 0.682272 11.909 0.60887 11.6404 0.616791C11.294 0.627112 10.9652 0.771884 10.7237 1.02044L6.99978 4.7444L3.27583 1.02044C3.15142 0.892553 3.00262 0.790936 2.83823 0.721602C2.67384 0.652268 2.49721 0.616627 2.3188 0.616791Z"
                  fill="white"/>
            </svg>
          </div>
        </div>
      </b-collapse>

      <div class="chat-input-grid">
        <div class="form-block">
          <div>
            <textarea class="message-text-2" id="text-field" rows="2" :class="{'local-error': error}"
                      @click="setSeen"
                      placeholder="napíšte nám správu ..." v-model="message">
            </textarea>
          </div>
        </div>
        <div class="chat-ctas">
          <div class="sub-ctass">
            <label for="file-upload" class="custom-file-upload">
              <img
                  src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/6500af9c67c49109435e562e_upload%20icon.svg">
            </label>
            <input @change="handleFiles" id="file-upload" type="file"/>
          </div>
          <button @click="sendMessage" :disabled="!message.length && !file"
                  class="sendmessage"></button>
        </div>
      </div>
    </div>

    <!-- <div v-if="externDomain && !externDomainExpanded" class="calculator-banner-wrapper">
      <banner-remarketing></banner-remarketing>
    </div> -->
    <!-- </div> -->
  </div>
</template>

<script>
import Message from "./Message";
import {mapGetters} from "vuex";
import ApiController from "@/mixins/ApiController";
// import BannerRemarketing from "./BannerRemarketing";

export default {
  name: "Chat",
  components: {
    Message,
    // BannerRemarketing
  },
  mixins: [ApiController],
  data: () => ({
    expanded: false,
    message: "",
    messages: [],
    clientId: null,
    channel: null,
    file: null,
    fileName: null,
    error: false,
    newMessage: false,
    newMessages: [],
    init: true,
    recipientId: null,
    refresh: null,
    fileCollapsed: false,
    broker: {
      firstName: "",
      lastName: ""
    },
    externDomain: true,
    externDomainExpanded: true,
    sendingFirst: false,
  }),
  props: {
    fromDashboard: Boolean
  },
  mounted() {
    // this.externDomain = !this.defaultUrls.includes(window.location.origin);
    // // this.externDomain = true;

    // if (!this.externDomain)
    //   this.externDomainExpanded = true;

    if (document.getElementById("text-field"))
      document.getElementById("text-field").addEventListener("keydown", e => {
        if (e.keyCode === 13) {
          e.preventDefault();
          this.sendMessage();
        }
      });

    const el = document.getElementById("chat");

    if (el)
      el.addEventListener("click", () => {
        if (window.innerWidth < 991)
          this.expanded = true;
        else {
          const el = document.getElementById("chat-main");
          el.scrollIntoView({behavior: "smooth", block: "end"});
        }
      });
    else {
      const adEl = document.getElementById("chat-trigger");

      if (adEl)
        adEl.addEventListener("click", () => {
          this.expanded = true;
        });
    }

    const listener = () => {
      if (window.innerWidth < 991)
        this.externDomainExpanded = true;
    }

    listener();
    window.addEventListener("resize", listener);
  },
  methods: {
    async afterInit() {
      this.clientId = this.$store.getters.getClientId;

      if (!this.sendingFirst)
        await this.initMessages();

      this.openChannel();
    },
    openChannel() {
      setInterval(async () => {
        await this.initMessages();
      }, 5000);
    },
    deleteFile() {
      this.file = null;

      document.getElementById("file-upload").type = "text";
      document.getElementById("file-upload").type = "file";
      setTimeout(() => {
        this.fileName = null;
      }, 300);
    },
    async initMessages() {
      const response = await this.$axios.get(`chat-message/?sender_or_recipient=${this.clientId}`);

      this.messages = response.data.results.reverse();

      this.newMessages = this.messages.filter((message) => {
        return message["seen_at"] === null && message["sender"] !== this.clientId;
      });

      if (this.newMessages.length > 0) {
        this.newMessage = true;
      }
    },
    setSeen() {
      if (this.newMessage) {
        this.newMessage = false;

        this.newMessages.forEach((message) => {
          this.$axios.post(`chat-message/${message.id}/set-seen/`);
        });

        this.newMessages = [];
      }
    },
    getBase64(file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.file = reader.result;
      }
    },
    handleFiles() {
      const file = document.getElementById("file-upload").files[0];
      this.fileName = file.name;
      this.getBase64(file);
    },
    async sendMessage() {
      if (!this.applicantStore) {
        this.sendingFirst = true;
        await this.addClient();
      }

      if (!this.recipientId)
        this.recipientId = this.getBroker(window.location.origin);

      if (!(this.message || this.file)) {
        this.error = true;
      }

      //Ak sa jedná o príkaz
      if (this.message && this.message.charAt(0) === "/") {
        switch (this.message) {
          case "/ntu":
            await this.$axios.post("auth/logout/");

            await this.$axios.post("auth/temp-client/", {
              auto_login: true
            });

            window.location.reload();
            break;
          case "/logout":
            await this.$axios.post("auth/logout/");

            window.location.reload();
            break;
          default:
            alert("Neznámy príkaz");
            break;
        }

        this.message = "";

        return;
      }

      this.error = false;

      this.messages.push({
        content: this.message ? this.message : "súbor",
        sender: this.clientId,
        seen_at: null,
        attachment: this.file || undefined,
        attachment_filename: this.fileName || undefined
      });

      if (this.fileName)
        this.fileName = this.fileName.replace(/\s/g, '');

      await this.$axios.post("chat-message/", {
        recipient: this.recipientId,
        content: this.message ? this.message : "súbor",
        attachment: this.file,
        attachment_filename: this.fileName,
        meta: null
      });

      this.sendingFirst = false;

      this.message = "";
      this.deleteFile();
    },
  },
  computed: {
    ...mapGetters({
      applicantStore: "getApplicant"
    }),

    isChatOnline() {
      const slovakDate = new Date();

      return ((slovakDate.getHours() < 17 && slovakDate.getHours() >= 9) && (slovakDate.getDay() < 6 && slovakDate.getDay() > 0));
    },
  },
  watch: {
    async "messages"(to, from) {
      if (!from.length) {
        const recievedMessages = this.messages.filter(mess => mess.sender !== this.clientId);

        if (recievedMessages.length)
          this.recipientId = recievedMessages[recievedMessages.length - 1].sender;
      }
    },
    newMessage(to) {
      if (to) {
        this.recipientId = this.newMessages[this.newMessages.length - 1].sender;

        const snd = new Audio(require("@/assets/new_message.wav"));
        snd.play();

        this.expanded = true;
      }
    },
    async recipientId(to) {
      if (to) {
        const response = await this.$axios.get(`safe-staff/${to}/`);
        this.broker = {
          firstName: response.data["first_name"],
          lastName: response.data["last_name"],
          profileImage: response.data["profile_image"]
        }
      }
    },
    file(to) {
      this.fileCollapsed = Boolean(to);

      const interval = window.setInterval(() => {
        const collapseHeight = document.getElementById("collapse-1").clientHeight;
        const el = document.getElementsByClassName("chat-panel-grid")[0];
        el.style.height = `calc(100% - 162px - ${collapseHeight}px)`;
        // console.log(el.style.height)
      }, 50);

      window.setTimeout(() => {
        window.clearInterval(interval);
      }, 300);
    },
    async "$store.getters.getInitCompleted"(to) {
      if (to)
        await this.afterInit();
    }
  }
}
</script>

<style lang="scss" scoped>

.leaveEmailBanner {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  width: auto;
  padding: 20px;
  text-align: left;
  font-size: 14px;
  background-color: #edf5f7;
  color: #11845b;
  font-weight: 500;
}

.chat-panel-grid {
  position: relative !important;
}

</style>
